$(function() {
  const shop_list = $('.product-grid');
  const products = shop_list.find('li.grid__item');
  const productCount = products.length;

  const bannerWraps = $('.shop_list_banner_wrap');
  if (bannerWraps.length === 0) return;

  const banners = bannerWraps.map(function() {
    return $(this).html();
  }).get();

  bannerWraps.hide();

  let insertPositions = [];

  if (productCount >= 10) {
    insertPositions = [3, 8, 18];
  } else if (productCount >= 8) {
    insertPositions = [3, 4, 18];
  } else if (productCount >= 4 && productCount <= 7) {
    insertPositions = [4];
  } else if (productCount <= 2) {
    insertPositions = [3];
    //insertPositions = ['end'];
  }

  insertPositions.forEach((pos, idx) => {
    const bannerHtml = banners[idx % banners.length];
    const bannerItem = $('<li class="grid__item shop_list_banner_item">' + bannerHtml + '</li>');

    bannerItem.append('<div class="card__badge bottom left banner_badge"><span class="badge">10% OFF</span></div>');

    if (pos === 'end') {
      shop_list.append(bannerItem);
    } else {
      const target = products.eq(pos - 1);
      if (target.length) {
        bannerItem.insertBefore(target);
      } else {
        shop_list.append(bannerItem);
      }
    }
  });
});
